import { useTranslation } from 'react-i18next'
import { NoBookContainer } from './style'

function NoBook() {
  const { t } = useTranslation()

  return (
    <NoBookContainer>
      <h1 className="title">{t('no_books')}</h1>
      <h3 className="description">{t('please_add_book')}</h3>
    </NoBookContainer>
  )
}

export default NoBook
